import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import NxtbnModal from '../Modal';
import useApi from "../../api";
import { NXForm, InputField } from "../common";
import { handleRetriveError } from "../../utils";

interface VariantStockModificationProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  variant?: any;
}

function VariantStockModification({ isOpen, onClose, onSubmit, variant }: VariantStockModificationProps) {
  const [formData, setFormData] = useState<any>([]);
  const [errorData, setErrorData] = useState<any>({});

  const api = useApi();

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    api.updateStockWarehouseWise(variant, formData).then((response: any) => {
        onSubmit();
        toast.success("Stock updated successfully!");
        onClose();
      },
      (error) => {
        toast.error("Failed to update stock!");
        setErrorData(error.response.data);
      }
    );
  };

  const handleChange = (index: number, field: string, value: string) => {
    const updatedData = [...formData];
    updatedData[index][field] = value;
    setFormData(updatedData);
  };


  useEffect(() => {

    if (variant) {
      api.getWarehouseWiseVariantStock(variant).then(
        (response: any) => {
          const updatedData = response.map((item: any) => ({
            ...item,
            warehouse: item.warehouse_id,
          }));
          setFormData(updatedData);
        },
        handleRetriveError
      );
    }
  }, [variant]);

  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      <NXForm
        onSubmit={handleSave}
        className="p-6"
        title="Stock Details for Variant"
        nonFieldError={{}}
      >
        <div className="mt-4">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Warehouse
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Stock
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Reserved Stock
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Available for quantity
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {formData.map((item: any, index: number) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {item.warehouse_name}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <InputField
                      type="number"
                      name={`quantity-${index}`}
                      value={item.quantity}
                      errorData={errorData}
                      onChange={(e) => handleChange(index, 'quantity', e.target.value)}
                      className="w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <p>{item.reserved_quantity}</p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <p>{item.available_quantity}</p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Save
          </button>
        </div>
      </NXForm>
    </NxtbnModal>
  );
}

export default VariantStockModification;
